import { assert } from '@sama/js-core';
import { omit, pick } from '@sama/micro-dash';
import {
  KeypointShapeState,
  ShapeState2D,
} from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { Dimensions } from '../../../cross-team-shared/types/misc';
import { PartiallyTransformedShape } from '../../../team-apis/content/content-utils';
import {
  Point2D,
  VectorTaggingShapeType,
} from '../../../team-apis/otterdam/answers/shape-typings';
import { makeRandomSubpoints, ShapeHelper } from './shape-helper';

export class KeypointShapeHelper extends ShapeHelper {
  override allowsSubpointSelection = true;

  override areSubpointsDeletable(_points: Point2D[]) {
    return false;
  }

  override convertShapeStateToAnswer(shapeState: ShapeState2D) {
    // This casting is necesary to avoid typing issues.
    assert(
      this.isKeypointShapeState(shapeState),
      'This has to be a keypoint shape state.',
    );
    const keypointClass = shapeState.keypointClass;
    return {
      ...pick(shapeState, 'type', 'index', 'source', 'dynamic_tags'),
      tags: { ...shapeState.tags, keypoint_class: keypointClass },
      key_locations: shapeState.key_locations,
    };
  }

  override addKeyLocationsToShapeExternal(
    shapeExternal: PartiallyTransformedShape<Point2D, VectorTaggingShapeType>,
  ) {
    return {
      ...shapeExternal,
      keypointClass: shapeExternal.tags.keypoint_class,
      tags: omit(shapeExternal.tags, 'keypoint_class'),
    };
  }

  override makeRandomPoints(imageSize: Dimensions, pointCount: number) {
    return makeRandomSubpoints(imageSize, pointCount);
  }

  isKeypointShapeState(
    shapeState: ShapeState2D,
  ): shapeState is KeypointShapeState {
    return 'keypointClass' in shapeState;
  }
}
